import maplibregl from 'maplibre-gl';
import { toast } from '../ui/toast.js';

const SOURCE_ID = 'csv-quick-import';
const LAYER_ID  = 'csv-quick-import-pts';

export function importCSV(map) {
  const raw = document.getElementById('csvInput').value.trim();
  if (!raw) { toast('Paste CSV data first'); return; }

  const lines = raw.split('\n');
  if (lines.length < 2) { toast('Need header + at least 1 row'); return; }

  const headers = lines[0].split(',').map(h => h.trim().toLowerCase());
  const latIdx  = headers.findIndex(h => h === 'lat' || h === 'latitude'  || h === 'y');
  const lngIdx  = headers.findIndex(h => h === 'lng' || h === 'longitude' || h === 'lon' || h === 'x');
  if (latIdx < 0 || lngIdx < 0) { toast('CSV needs lat/lng columns'); return; }

  const nameIdx = headers.findIndex(h => h === 'name' || h === 'label' || h === 'id');
  const features = [];

  for (let i = 1; i < lines.length; i++) {
    const cols = lines[i].split(',').map(c => c.trim());
    const lat  = parseFloat(cols[latIdx]);
    const lng  = parseFloat(cols[lngIdx]);
    if (isNaN(lat) || isNaN(lng)) continue;
    features.push({
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [lng, lat] },
      properties: { name: nameIdx >= 0 ? cols[nameIdx] : `Point ${i}`, row: lines[i] }
    });
  }

  if (!features.length) { toast('No valid coordinates found'); return; }

  // Lazy-mount the source/layer the first time the user pastes a CSV.
  if (!map.getSource(SOURCE_ID)) {
    map.addSource(SOURCE_ID, { type: 'geojson', data: { type: 'FeatureCollection', features: [] } });
    map.addLayer({
      id: LAYER_ID, type: 'circle', source: SOURCE_ID,
      paint: {
        'circle-radius':       6,
        'circle-color':        '#04648d',
        'circle-stroke-color': '#ffffff',
        'circle-stroke-width': 1.5,
        'circle-opacity':      0.9,
      },
    });
  }
  map.getSource(SOURCE_ID).setData({ type: 'FeatureCollection', features });

  const bounds = new maplibregl.LngLatBounds();
  features.forEach(f => bounds.extend(f.geometry.coordinates));
  map.fitBounds(bounds, { padding: 80, maxZoom: 12, duration: 1200 });

  toast(`Plotted ${features.length} points from CSV`);
}
